import React, { useEffect, useState } from "react";
import { supabase } from "../config/supabase";

const PRODUCTS = [
  {
    key: "analytics",
    name: "Options Analytics",
    description: "Advanced options analytics & insights",
    url: "https://analytics.easygreeks.com",
    comingSoon: false,
  },

  {
    key: "nism_ra",
    name: "NISM Research Analyst",
    description: "Chapter-wise learning & smart practice",
    url: "https://learn.easygreeks.com/certifications/nism-ra",
    comingSoon: false,
  },

  {
    key: "nism_ia",
    name: "NISM Investment Advisor",
    description: "Preparation for Investment Advisor certification",
    url: "#",
    comingSoon: true,
  },
];

export default function Dashboard() {
  const [user, setUser] = useState(null);
  const [subs, setSubs] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    try {
      const params = new URLSearchParams(window.location.search);
      const access_token = params.get("access_token");
      const refresh_token = params.get("refresh_token");

      if (access_token && refresh_token) {
        await supabase.auth.setSession({
          access_token,
          refresh_token,
        });

        window.history.replaceState(
          {},
          document.title,
          window.location.pathname
        );
      }

      const { data } = await supabase.auth.getUser();

      if (!data?.user) {
        window.location.href = "https://easygreeks.com/login";
        return;
      }

      setUser(data.user);

      const { data: subscriptions } = await supabase
        .from("subscriptions")
        .select("*")
        .eq("user_id", data.user.id);

      const map = {};
      subscriptions?.forEach((s) => {
        map[s.product] = s.status;
      });

      setSubs(map);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleClick = async (product) => {
    if (product.comingSoon) return;

    const { data: sessionData } = await supabase.auth.getSession();

    const access_token = sessionData?.session?.access_token;
    const refresh_token = sessionData?.session?.refresh_token;

    window.location.href = `${product.url}?access_token=${access_token}&refresh_token=${refresh_token}`;
  };

  const handleLogout = async () => {
    await supabase.auth.signOut();
    window.location.href = "https://easygreeks.com";
  };

  if (loading) {
    return (
      <div className="center">
        <p>Loading dashboard...</p>
      </div>
    );
  }

  return (
    <div className="dashboard">
      <div className="header">
        <div>
          <h1>easygreeks</h1>
          <p className="sub">Welcome back</p>
        </div>

        <div className="user-box">
          <span>{user?.email}</span>
          <button className="logout" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>

      <div className="grid">
        {PRODUCTS.map((product) => {
          const isActive =
            product.key === "analytics"
              ? subs[product.key] === "active"
              : true;

          return (
            <div
              key={product.key}
              className={`card ${product.comingSoon ? "disabled" : ""}`}
              onClick={() => handleClick(product)}
            >
              <div className="card-top">
                <h3>{product.name}</h3>

                <span
                  className={
                    product.comingSoon
                      ? "badge soon"
                      : isActive
                      ? "badge active"
                      : "badge inactive"
                  }
                >
                  {product.comingSoon
                    ? "Coming Soon"
                    : isActive
                    ? "Active"
                    : "Locked"}
                </span>
              </div>

              <p className="desc">{product.description}</p>

              <button
                className={
                  product.comingSoon
                    ? "btn disabled-btn"
                    : isActive
                    ? "btn primary"
                    : "btn outline"
                }
              >
                {product.comingSoon
                  ? "Coming Soon"
                  : isActive
                  ? "Open App →"
                  : "Subscribe →"}
              </button>
            </div>
          );
        })}
      </div>

      <style>{`
        body {
          margin: 0;
          font-family: Inter, sans-serif;
          background: #f6f8fb;
        }

        .dashboard {
          max-width: 1100px;
          margin: auto;
          padding: 40px 20px;
        }

        .header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 40px;
        }

        h1 {
          margin: 0;
        }

        .sub {
          color: #666;
          font-size: 14px;
        }

        .user-box {
          display: flex;
          align-items: center;
          gap: 15px;
        }

        .logout {
          background: #111;
          color: white;
          border: none;
          padding: 8px 14px;
          border-radius: 6px;
          cursor: pointer;
        }

        .grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
          gap: 24px;
        }

        .card {
          background: white;
          border-radius: 14px;
          padding: 22px;
          cursor: pointer;
          transition: all 0.25s ease;
          border: 1px solid #eee;
        }

        .card:hover {
          transform: translateY(-6px);
          box-shadow: 0 10px 25px rgba(0,0,0,0.08);
        }

        .card.disabled {
          opacity: 0.75;
          cursor: not-allowed;
        }

        .card-top {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .badge {
          font-size: 12px;
          padding: 4px 10px;
          border-radius: 20px;
        }

        .badge.active {
          background: #e6f7ec;
          color: #1a7f37;
        }

        .badge.inactive {
          background: #ffeaea;
          color: #d92d20;
        }

        .badge.soon {
          background: #fff4e5;
          color: #b26a00;
        }

        .desc {
          margin: 12px 0 20px;
          color: #555;
          font-size: 14px;
        }

        .btn {
          width: 100%;
          padding: 10px;
          border-radius: 8px;
          font-weight: 500;
          cursor: pointer;
          border: none;
        }

        .btn.primary {
          background: #2563eb;
          color: white;
        }

        .btn.outline {
          border: 1px solid #ccc;
          background: white;
        }

        .disabled-btn {
          background: #e5e7eb;
          color: #666;
          cursor: not-allowed;
        }

        .center {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100vh;
        }
      `}</style>
    </div>
  );
}